
<template>
  <span @click="showModal">
    <span v-if="!isApi" style="cursor: pointer;">
      <slot name="user" :data="selectUserResultList">
        <span v-if="selectUserResultList.length == 0 && disabled">{{
          placeholder
        }}</span>
        <el-button v-else class="text-align-left choseUser" size="small">
          <span
            v-if="selectUserResultList.length == 0"
            style="color: #bfbfbf"
          >{{ placeholder }}</span>
          <div v-else style="text-align: left; white-space: normal">
            <el-tag
              v-for="(user, index) in selectUserResultList"
              :key="index"
              style="margin: 4px"
              size="small"
            >{{ user.userName }}</el-tag>
          </div>
        </el-button>
      </slot>
    </span>

    <el-dialog
      title="选择用户"
      :visible.sync="visible"
      width="950px"
      class="custom-dialog"
      append-to-body
      @closed="handleAfterLeave()"
    >
      <div style="height: 60px; overflow: auto; padding: 0px 5px 5px 5px">
        <el-tag
          v-for="(user, index) in selectUserList"
          :key="index"
          closable
          style="margin-top: 5px"
          @close="deleteUser(index)"
        >{{ user.userName }}（{{ user.userLoginName }}）</el-tag>
      </div>
      <el-row type="flex" justify="start" align="top">
        <el-col style="width: 300px">
          <el-card
            header="组织架构"
            shadow="never"
            :body-style="{ height: '350px', overflow: 'auto' }"
          >
            <el-input
              v-model="filterText"
              placeholder="请输入关键字进行过滤"
              clearable
              size="small"
            />
            <el-tree
              ref="tree"
              highlight-current
              :expand-on-click-node="false"
              node-key="busOrganId"
              :data="organTreeData"
              :props="{ children: 'children', label: 'organName' }"
              :filter-node-method="filterNode"
              style="margin-top: 10px"
              :default-expanded-keys="idArr"
              @node-click="selectOrganCallback"
            >
              <span slot-scope="{ node, data }" class="custom-tree-node">
                <el-tag
                  size="mini"
                  :style="{
                    color: '#333',
                    background: '#EDEDED',
                    borderColor: '#EDEDED',
                  }"
                >{{ ORGAN_TYPE[data.organType] }}</el-tag>
                <span
                  class="dib"
                  style="
                    font-size: 14px;
                    max-width: 100px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                  "
                >{{ node.label }}({{ data.userCount }})</span>
              </span>
            </el-tree>
          </el-card>
        </el-col>
        <el-col style="width: 650px">
          <el-card
            v-loading="tableLoading"
            header="用户列表"
            shadow="never"
            :body-style="{ height: '350px' }"
          >
            <div class="margin-bottom">
              <span>姓名/登录账户：</span>
              <el-input
                v-model="searchParam.search"
                style="width: 200px; margin-right: 10px"
                placeholder="请输入姓名/登录账户"
                clearable
                size="small"
                @keyup.enter.native="searchUser"
              />
              <el-button
                type="primary"
                icon="search"
                size="small"
                @click="searchUser"
              >搜索</el-button>
            </div>
            <el-table
              ref="userTable"
              :data="userData"
              style="width: 100%; margin-top: 10px"
              max-height="240"
              row-key="busUserId"
              border
              size="small"
              highlight-current-row
              @select="select"
              @select-all="selectAll"
              @current-change="changeSelectRow"
              @selection-change="selectionChange"
            >
              <el-table-column v-if="limit != 1" type="selection" width="50" />
              <el-table-column v-if="limit == 1" type="index" width="50">
                <template slot-scope="scope">
                  <el-radio
                    v-model="userId.busUserId"
                    :label="scope.row.busUserId"
                  >&nbsp;</el-radio>
                </template>
              </el-table-column>
              <el-table-column property="userName" label="姓名" width="120" />
              <el-table-column
                property="userLoginName"
                label="登录账号"
                width="120"
              />
              <el-table-column property="userPost" label="所属组织">
                <template slot-scope="scope">
                  <span
                    v-if="scope.row.userPost == null ||scope.row.userPost.length === 0"
                  >-</span>
                  <el-popover
                    v-else
                    placement="left"
                    trigger="hover"
                    :open-delay="200"
                  >
                    <div slot="reference">
                      <p
                        v-for="(item, index) in scope.row.userPost"
                        v-show="index < 5"
                        :key="index"
                      >
                        {{ item }}
                      </p>
                      <p v-if="scope.row.userPost.length > 3">...</p>
                    </div>
                    <template>
                      <p
                        v-for="(item, index) in scope.row.userPost"
                        :key="index"
                      >
                        {{ item }}
                      </p>
                    </template>
                  </el-popover>
                </template>
              </el-table-column>
            </el-table>
            <pagination
              :total="userDataTotal"
              :page.sync="searchParam.page.pageNum"
              :limit.sync="searchParam.page.pageSize"
              background
              :auto-scroll="false"
              layout="total, prev, pager, next, sizes"
              @pagination="searchUser('page')"
            />
          </el-card>
        </el-col>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button @click="visible = false">取 消</el-button>
        <el-button type="primary" @click="submit">确 定</el-button>
      </span>
    </el-dialog>
  </span>
</template>

<script>
import { deepClone } from '@/utils'
import { ORGAN_TYPE } from '@/enum'
import {
  accountManagementTreeData,
  busUserUserData,
  choseBusUser_selectUserInfo
} from '@/api/common'
export default {
  name: 'UmBusUser',
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    organType: {
      type: Array,
      default: () => [1, 2, 3, 4]
    },
    organNature: {
      type: Array,
      default: () => [0, 1]
    },
    placeholder: {
      type: String,
      default: '请选择'
    },
    // 默认已选择用户id 数组
    value: {
      type: Array,
      default: () => []
    },
    limit: {
      type: [Number, String],
      default: 1
    },
    projectId: {
      // 检查用户是否拥有此项目权限
      type: [Number, String],
      default: null
    },
    buildingId: {
      // 检查用户是否拥有此楼栋权限
      type: Number,
      default: null
    },
    contractId: {
      // 检查用户是否拥有此合同权限
      type: Number,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      idArr: [],
      ORGAN_TYPE,
      filterText: '',
      isApi: false, // 是否API唤起
      callback: null,
      visible: false, // 显示弹框
      selectUserResultList: [], // 用户返回数据
      selectUserList: [], // 用户选择数据
      organTreeData: [], // 组织树数据
      searchParam: {
        busOrganId: '', // 组织ID
        search: '', // 用户名
        page: {
          pageSize: 10,
          pageNum: 1
        }
      },
      userId: {
        // 单选的时候使用
        busUserId: ''
      },
      userData: [], // 用户数据
      userDataTotal: 0, // 用户数据总量
      tableLoading: false
    }
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val)
    },
    visible(val) {
      if (!val) {
        // this.$refs.userTable.clearSelection()
        // this.$refs.userTable.setCurrentRow()
        this.selectUserList = []
      } else {
        this.selectUserInfo()
      }
    },
    // 监听
    value: {
      handler(val) {
        if (val === null || val === undefined) {
          return false
        }
        const list = this.selectUserResultList.map((item) => {
          return item.busUserId
        })
        if (JSON.stringify(val) === JSON.stringify(list)) {
          return false
        }
        let sum = 0
        this.selectUserList.forEach((item) => {
          if (val.indexOf(item.busUserId) !== -1) {
            sum++
          }
        })
        if (
          val.length === 0 ||
          val.length !== this.selectUserList.length ||
          sum !== this.selectUserList.length
        ) {
          console.log('value 值修改了:', val)
          this.selectUserInfo()
        }
      },
      immediate: true
    }
  },
  created() {
    // this.selectUserInfo()
    console.log(this.value)
  },
  mounted() {
    // this.showModal()
  },
  methods: {
    filterNode(value, data) {
      if (!value) return true
      return data.organFullName.indexOf(value) !== -1
    },
    handleAfterLeave() {
      if (!this.isApi) {
        return false
      }
      this.$destroy(true)
      this.$el.parentNode.removeChild(this.$el) // 可能移除的时候组件已经不存在了
    },
    // 拉取用户信息
    selectUserInfo() {
      if (this.value == null || this.value.length === 0) {
        this.selectUserResultList = []
        this.selectUserList = []
        this.$refs.userTable && this.$refs.userTable.clearSelection()
        this.$refs.userTable && this.$refs.userTable.setCurrentRow()
        return
      }
      choseBusUser_selectUserInfo({ busUserIdList: this.value })
        .then((data) => {
          if (data.data.length === 0) {
            this.$emit('change', [])
            return false
          }
          if (this.limit !== 0) {
            this.selectUserList = data.data.slice(0, this.limit)
          } else {
            this.selectUserList = data.data
          }
          this.selectUserResultList = deepClone(this.selectUserList)
          this.searchUser()
          const list = this.selectUserList.map((item) => {
            return item.busUserId
          })
          if (JSON.stringify(this.value) === JSON.stringsify(list)) {
            return false
          }
          this.$emit('change', list)
        })
        .catch((data) => {})
    },
    showModal() {
      if (this.disabled) return false
      this.visible = true
      if (this.organTreeData.length === 0) {
        this.selectOrganTree()
      }
    },
    // 获取组织架构
    selectOrganTree() {
      accountManagementTreeData({
        filterOrganType: this.organType,
        filterOrganNature: this.organNature,
        checkProject: this.projectId,
        checkBuilding: this.buildingId,
        checkContract: this.contractId
      }).then((d) => {
        console.log(d)
        this.organTreeData = d.data
        this.organTreeData.forEach((item) => {
          this.idArr.push(item.busOrganId)
        })
        if (d.data && d.data.length) {
          this.$nextTick(() => {
            this.$refs.tree.setCurrentKey(
              this.organTreeData[0].busOrganId,
              true
            ) // 默认选中第一个节点
          })
        }
        this.selectOrganCallback(this.organTreeData[0])
      })
    },
    // 修改选中的组织架构节点
    selectOrganCallback(data, node, component) {
      if (data) {
        if (this.searchParam.busOrganId === data.busOrganId) {
          return false
        }
        this.searchParam.busOrganId = data.busOrganId
      }
      this.searchUser()
    },
    // 搜索用户
    searchUser(state) {
      if (state !== 'page') {
        // this.searchParam.page.pageSize = 10
        this.searchParam.page.pageNum = 1
      }
      if (!this.searchParam.busOrganId) {
        return false
      }
      this.tableLoading = true
      busUserUserData({
        ...this.searchParam,
        checkProject: this.projectId,
        checkBuilding: this.buildingId,
        checkContract: this.contractId
      }).then((d) => {
        this.tableLoading = false
        this.userData = d.data.list
        this.userDataTotal = d.data.page.total
        // 请求用户接口之后做选中处理
        if (this.limit === 1) {
          this.$refs.userTable.setCurrentRow(this.selectUserList[0])
        } else {
          this.$refs.userTable.clearSelection()
          this.userData.forEach((item, index) => {
            if (
              this.selectUserList.some((i) => i.busUserId === item.busUserId)
            ) {
              this.$nextTick(() => {
                this.$refs.userTable.toggleRowSelection(
                  this.userData[index],
                  true
                )
              })
            }
          })
        }
      }).catch(e => {
        this.$errorHandle(e)
        this.tableLoading = false
      })
    },
    // 单选的时候使用
    changeSelectRow(selection) {
      console.log(selection)
      if (this.limit !== 1) {
        return false
      }
      this.selectUserList = []
      if (selection) {
        this.userId = selection
        this.selectUserList.push(selection)
      } else {
        this.userId = { busUserId: '' }
      }
    },
    // 多选的时候使用
    selectionChange(selection) {
    },
    select(selection, row) {
      let checked = false
      checked = selection.some((item) => item.busUserId === row.busUserId)
      console.log(checked)
      if (checked) {
        if (this.limit !== 0 && selection.length > this.limit) {
          this.$refs.userTable.toggleRowSelection(row, false)
          return false
        }
        const hasChild = this.selectUserList.some(
          (item) => item.busUserId === row.busUserId
        )
        if (!hasChild) {
          this.selectUserList.push(row)
        }
      } else {
        this.selectUserList = this.selectUserList.filter(
          (item) => item.busUserId !== row.busUserId
        )
      }
    },
    selectAll(selection) {
      console.log(selection)
      if (this.limit !== 0 && selection.length > this.limit) {
        this.$message.info(`最多选择${this.limit}人!`)
        this.$refs.userTable.clearSelection()
        this.selectUserList = []
        return false
      }
      const list = this.selectUserList.filter((item) => {
        return !this.userData.some((i) => i.busUserId === item.busUserId)
      })
      this.selectUserList = list.concat(selection) // 因为开启了selection缓存，以及在数据加载的时候同步了选中状态
    },
    submit() {
      this.visible = false
      this.selectUserResultList = [].concat(this.selectUserList)
      const list = this.selectUserResultList.map((item) => {
        return item.busUserId
      })
      this.$emit('change', list)
      this.$emit('changeItem', deepClone(this.selectUserResultList))
      this.callback && this.callback(deepClone(this.selectUserResultList), list)
    },
    // 删除用户
    deleteUser(id) {
      let current = {}
      const list = this.selectUserList.filter((currentValue, index, arr) => {
        if (index === id) {
          current = currentValue
          return false
        } else {
          return true
        }
      })
      console.log(current)
      this.selectUserList = list
      if (this.limit === 1) {
        this.$refs.userTable.setCurrentRow()
      } else {
        if (list.length === 0) {
          this.$refs.userTable.clearSelection()
        }
        this.userData.forEach((item, index) => {
          if (item.busUserId === current.busUserId) {
            this.$refs.userTable.toggleRowSelection(item, false)
          }
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.custom-dialog {
  ::v-deep .el-dialog__header {
    padding-bottom: 0;
  }
  ::v-deep .el-dialog__body {
    padding: 0 5px;
  }
  ::v-deep .el-card__body {
    padding: 10px;
  }
}
::v-deep .el-tag {
  margin-right: 5px;
}
</style>
